var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1313 12.9479H13.0612V19.9567C13.0612 21.0852 12.1384 22 11 22C9.86164 22 8.93882 21.0852 8.93882 19.9567V12.9479H1.86875C0.806912 12.8389 0 11.9519 0 10.8936C0 9.83537 0.806912 8.94835 1.86875 8.83934H8.91666V1.85255C9.02662 0.799916 9.9214 0 10.9889 0C12.0564 0 12.9512 0.799916 13.0612 1.85255V8.83934H20.1313C21.1931 8.94835 22 9.83537 22 10.8936C22 11.9519 21.1931 12.8389 20.1313 12.9479Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBig);
export default __webpack_public_path__ + "static/media/plus-big.20b7bb78022c91e374cd1e92f29e2da1.svg";
export { ForwardRef as ReactComponent };